import { render } from "./SplashImage.vue?vue&type=template&id=1e095405"
import script from "./SplashImage.vue?vue&type=script&lang=js"
export * from "./SplashImage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__